/* eslint-disable import/no-named-as-default */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import maska from 'maska';
import VueClipboard from 'vue3-clipboard';

import { SnackbarService, Vue3Snackbar } from '@/packages/vue3-snackbar';
import i18n from '@/packages/i18n';
import { loadLocaleMessages, getPersistedLocale } from '@/packages/i18n/translation';
import ToastManager from '@/components/ui/alerts/ToastManager.vue';

import http from '@/composables/api/http';
import useRefreshLocalStorage from '@/composables/storage/useRefreshLocalStorage';

const { refreshLocalStorage } = useRefreshLocalStorage();

function bootstrap() {
  Promise.all([import('./router'), import('./App.vue')]).then(async ([routerModule, AppModule]) => {
    const router = routerModule.default;
    const App = AppModule.default;
    const app = createApp(App);
    app.provide('http', http);
    app.use(maska);
    app.use(createPinia());
    app.use(router);
    app.use(VueClipboard, {
      autoSetContainer: true,
      appendToBody: true,
    });
    app.component('ToastManager', ToastManager);
    app.use(SnackbarService);
    app.component('vue3-snackbar', Vue3Snackbar);
    app.use(i18n);

    await loadLocaleMessages(getPersistedLocale());
    await import('@/packages/third-party/datadog').then((m) => m.default()).catch(() => {});
    app.mount('#space');

    import('gsap/gsap-core').then(({ gsap }) => {
      app.provide('$gsap', gsap);
    });

    if (
      import.meta.env.VITE_ENV !== 'local'
      && import.meta.env.VITE_ENV !== 'development'
    ) {
      refreshLocalStorage();
    }
  });
}

if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(() => bootstrap(), { timeout: 2000 });
} else {
  setTimeout(bootstrap, 0);
}
